export const Languages = [
    "Turkish",  // Turkey
    "German",   // Germany
    "French",   // France
    "Spanish",  // Spain
    "Italian",  // Italy
    "Portuguese",  // Portugal
    "Dutch",    // Netherlands
    "Greek",    // Greece
    "Dutch",    // Belgium
    "German",   // Austria
    "Slovak",   // Slovakia
    "Slovenian",  // Slovenia
    "Irish",    // Ireland
    "Finnish",  // Finland
    "Greek",    // Cyprus
    "Maltese",  // Malta
    "Lithuanian", // Lithuania
    "French",   // Monaco
    "Montenegrin", // Montenegro
    "Luxembourgish", // Luxembourg
    "Estonian", // Estonia
    "Latvian",  // Latvia
    "Italian",  // San Marino
    "Catalan",  // Andorra
    "German",   // Switzerland
    "English",  // United States
    "English",  // Canada
    "English",  // United Kingdom (England, Scotland, Wales)
    "Norwegian",  // Norway
    "Persian",    // Iran
    "English",    // Australia
    "Danish",     // Denmark
    "Russian",    // Russia
    "Swedish",    // Sweden
    "Japanese",   // Japan
    "Chinese",    // China
    "Hindi",      // India
    "Korean",     // South Korea
    "Portuguese", // Brazil
    "Spanish",    // Mexico
    "Afrikaans",  // South Africa
    "English"     // New Zealand
  ];